module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Bn8e4Y/tc-custom/9781646561926.jpg?1723404321489",
      "alt": "This image is the cover for the book Daimon"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Daimon\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("He was a romantic and a realist, a lover of strong women and beautiful men. And though he was at one time the richest, most powerful man in the world, his most prized possession was a book -- Homer’s "), _c('i', [_vm._v("The Iliad,")]), _vm._v(" annotated by his tutor, Aristotle."), _c('br'), _c('br'), _vm._v("Most of all, he was as much a myth as a man and a mystery ... even to himself."), _c('br'), _c('br'), _vm._v("When Alexander the Great died in Babylon in 323 B.C. a month shy of his 33rd birthday and after conquering and reordering Persia, he left a sprawling empire and a burning question: What drove him?"), _c('br'), _c('br'), _vm._v("Before Alexander, culture flowed East to West. After, it would flow West to East, and we are the heirs of the continuing tension between the two."), _c('br'), _c('br'), _vm._v("In this historical novel, Alexander encounters the only two enemies he cannot defeat: death and time. Surrendering to both, he considers a life that attempted to bridge seemingly irreconcilable opposites -- East and West, Persians and Greeks, a brutal father and a ruthless mother, a wily wife and a male soulmate. And above all, a tempered mind and ungovernable passions.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Georgette Gouveia\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0